// extracted by mini-css-extract-plugin
module.exports = {"di7261t":"di7261t","ch4mdji":"ch4mdji"};